import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ComponentStatusModelGroup } from '../../models';


@Injectable({
  providedIn: 'root'
})
export class ComponentStatusService {

  constructor(private httpClient: HttpClient) { }

  public getComponentStatuses(): Observable<ComponentStatusModelGroup[]> {
    const url = 'api/ComponentStatus';

    return this.httpClient.get<ComponentStatusModelGroup[]>(url);
  }
}
